import moment from 'moment';
import React from 'react';

import { getCloudfrontURI } from 'utilities/avatar';

import avatarPlaceholder from 'img/icons/comments-avatar-placeholder.svg';

import MoveToFolderBar from 'components/share-video/move-to-folder-bar';
import Tooltip from 'components/ui-components/tooltip';

import './styles.less';

const OwnerInfo = ({
  video,
  currentUserIsOwner,
  videoIsTeamShared,
  videoIsSharedWithUser,
}) => {
  const {
    owner_avatar: userAvatar,
    owner_full_name: name,
    createdAt: date,
    views,
  } = video;

  return (
    <div className="owner-info-and-move">
      <div className="owner-info">
        {userAvatar && userAvatar.thumb ? (
          <img src={getCloudfrontURI(userAvatar.thumb)} className="avatar" />
        ) : (
          <img src={avatarPlaceholder} className="placeholder" />
        )}
        <div className="by-date">
          <div className="by">
            <span>by </span>
            <span className="name">{name}</span>
          </div>
          <div className="date">
            {moment(date).format('LL')}
            {views &&
              !currentUserIsOwner &&
              !videoIsTeamShared &&
              !videoIsSharedWithUser && (
                <span className="analytics-icon">
                  <Tooltip>
                    {views.total} Total Views, {views.distinct} Unique
                    {views.distinct === 1 ? '' : 's'}
                  </Tooltip>
                </span>
              )}
          </div>
        </div>
      </div>
      <MoveToFolderBar />
    </div>
  );
};

export default OwnerInfo;
